const tooltips = {
  nyugtak: 'A nyugtákat kibocsátóra (kötelező), állapotra, egy megadott időszakra, illetve egy adott bizonylatszámra lehet lekérdezni a rendszerből. Helyszín jogosultság kezelése esetében csak az adott helyszín(ek)hez kapcsolódó nyugták kérdezhetőek le.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
